import Layout from "@components/Layout";
import {sortBy} from "lodash";
import {NextPage} from "next";
import Link from "next/link";
import {useTranslation} from "ni18n";
import React from "react";
import {v5Pages} from "src/components/_common/_constants";
import {useTypedSelector} from "src/store";
import {loadAppointmentReasons} from "@services/monolith/appointmentReasons";
import {PracticeId} from "src/constants/practiceIds";
import {NextReduxWrapper, actions} from "src/store";
import {RootStateApptReason} from "src/store/types";
import {isReasonDiscoverable} from "workers/common/isReasonDiscoverable";

import styles from "./stylesheets/get-care.module.scss";

const AppointmentReasons: NextPage = () => {
  const i18n = useTranslation();
  const {reasons} = useTypedSelector(({config}) => config);

  return (
    <Layout
      pageTitle={i18n.t("Carbon Health Services - Reasons")}
      pageDescription={i18n.t(
        "Carbon Health offers On-site, Virtual and Video Appointments for a Full Range of Adult & Pediatric Carbon Health Services, including X-Rays, Labs and More.",
      )}
    >
      <div className={`${styles.wrap} ph8 mt26 maxw80 ma`}>
        <h1 className="mb4">{i18n.t("Reasons")}</h1>
        <ul className={`${styles.items} basic`}>
          {sortBy(reasons, "name").map(
            reason =>
              reason && (
                <li className={styles.item} key={reason.id}>
                  <Link
                    href={{
                      pathname: `${v5Pages.getCareRoot}/${reason.slug}`,
                    }}
                    className="tac db color-default hover-sham"
                  >
                    <span className={`fs32 cIcon-${reason.iconName || "defaultReasonIcon"}`} />
                    <span className="db fx mt2 lh14 mh1-md">{i18n.t(reason.name)}</span>
                  </Link>
                </li>
              ),
          )}
        </ul>
      </div>
    </Layout>
  );
};

export const getServerSideProps = NextReduxWrapper.getServerSideProps<Record<string, never>>(
  store => async () => {
    if (!store.getState().config.reasons) {
      const reasons = ((await loadAppointmentReasons(PracticeId.CARBON)) || [])
        .map<RootStateApptReason>(reason => ({
          id: reason.id,
          slug: reason.slug ?? null,
          name: reason.name,
          iconName: reason.iconName ?? null,
          description: reason.description ?? null,
          specialtyIds: reason.specialtyIds,
          newPatientDuration: reason.newPatientDuration,
          supportsVideoVisit: reason.supportsVideoVisit,
          supportsInstantVisit: reason.supportsInstantVisit,
          practiceApptReasonSpecialties: reason.practiceApptReasonSpecialties,
          code: reason.code,
        }))
        .filter(r => isReasonDiscoverable(r));

      store.dispatch(
        actions.setConfig({
          reasons,
        }),
      );
    }

    return {props: {}};
  },
);

export default AppointmentReasons;
